import { useMyProfile } from "./hook/useMyProfile";
import LayoutDashBoard from "../../../components/layoutDashBoard/LayoutDashBoard";
import IdentityDetails from "../loan/IdentityDetails";
import AddressDetails from "../loan/AddressDetails";
import BankDetails from "../loan/BankDetails";
import { Button } from "../../../components/ui/Button";

export default function MyProfile() {
    const {
        addressDetails, bankDetails, identityDetails, onUpdateClientData
    } = useMyProfile();

    return (
        <LayoutDashBoard activeMenu={'Conta'}>
            <IdentityDetails identityDetails={identityDetails} />
            <AddressDetails addressDetails={addressDetails} />
            <BankDetails bankDetailsForm={bankDetails} />
        </LayoutDashBoard>
    );
}
